import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { ConferenceType } from 'features/call/call-conference/enums';

export interface ConferenceState {
  type: ConferenceType;
  url: string;
  isJoinedToZoom: boolean;
  didAgentLeaveConference: boolean;
  isCurrentlyInterpreting: boolean;
  participantCount: number;
  previousParticipantCount: number;
  vrsAgentConnectedToConferenceRoom: boolean;
}

export const initialConferenceState: ConferenceState = {
  type: ConferenceType.NONE,
  url: '',
  isJoinedToZoom: false,
  didAgentLeaveConference: false,
  isCurrentlyInterpreting: false,
  participantCount: 0,
  previousParticipantCount: 0,
  vrsAgentConnectedToConferenceRoom: false,
};

export const conferenceSlice = createSlice({
  name: 'conference',
  initialState: initialConferenceState,
  reducers: {
    setConferenceType: (state, action: PayloadAction<ConferenceType>) => {
      state.type = action.payload;
    },
    setConferenceUrl: (state, action: PayloadAction<string>) => {
      state.url = action.payload;
    },
    setJoinedToZoom: (state) => {
      state.isJoinedToZoom = true;
    },
    agentLeftConference: (state) => {
      state.didAgentLeaveConference = true;
    },
    interpretingStarted: (state) => {
      state.isCurrentlyInterpreting = true;
    },
    interpretingStopped: (state) => {
      state.isCurrentlyInterpreting = false;
    },
    agentJoinedToConferenceRoomSuccessfully: (state) => {
      state.vrsAgentConnectedToConferenceRoom = true;
    },
    participantCountUpdated: (state, action: PayloadAction<number>) => {
      const newNumber = action.payload;
      state.previousParticipantCount = state.participantCount;
      state.participantCount = newNumber;
      if (newNumber >= 3) {
        state.isCurrentlyInterpreting = true;
      } else {
        state.isCurrentlyInterpreting = false;
      }
    },
    resetConference: () => initialConferenceState,
  },
});

export const {
  setConferenceType,
  setConferenceUrl,
  setJoinedToZoom,
  resetConference,
  agentLeftConference,
  interpretingStarted,
  interpretingStopped,
  participantCountUpdated,
  agentJoinedToConferenceRoomSuccessfully,
} = conferenceSlice.actions;

export const conferenceReducer = conferenceSlice.reducer;
